import Base from './Base'

import User from './user/User'
import Subscription from './user/Subscription'

import Order from './shop/Order'
import Transaction from './shop/Transaction'

import Product from './store/Product'
import GenericProduct from './store/products/Generic'
import ReservationProduct from './store/products/Reservation'

import Image from './utils/media/image'
import Countdown from './utils/timer/Countdown'

import Errors from './errors'

export default {
  Errors,
  Base,
  Shop: {
    Order,
    Transaction
  },
  User: {
    User,
    Subscription
  },
  Store: {
    Product,
    Products: {
      ReservationProduct,
      GenericProduct
    }
  },
  Utils: {
    Countdown,
    Media: {
      Image,
    }
  }
}
